export const OnboardingStatus = {
  FULLY_ONBOARDED: 'FULLY_ONBOARDED',
  NOT_YET_ONBOARDED: 'NOT_YET_ONBOARDED',
  ONBOARDING_FAILED: 'ONBOARDING_FAILED',
  PENDING: 'PENDING',
} as const;

export type OnboardingStatusType =
  (typeof OnboardingStatus)[keyof typeof OnboardingStatus];
